import React from 'react';
import PropTypes from 'prop-types';
import {observable, action, reaction} from 'mobx';
import {observer} from 'mobx-react';

import {cn} from 'spa/css';

import './ProgressBar.less';

const HIDE_TIMEOUT = 1000;
const RESTART_TIMEOUT = 100;

@observer
class ProgressBar extends React.Component {
  static propTypes= {
    position: PropTypes.oneOf(['top', 'bottom']).isRequired,
    theme: PropTypes.oneOf(['primary', 'success', 'default', 'facebook']),

    loading: PropTypes.bool.isRequired,
    done: PropTypes.bool.isRequired,
    withRadius: PropTypes.bool,
  };
  static defaultProps = {theme: 'default'};

  @observable stage = 'invisible'; // invisible, start, loading or done

  componentDidMount() {
    let prevStage;
    this.listeners = [
      reaction(
        () => this.stage,
        (stage) => {
          if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
          }

          if (stage === 'done' && prevStage === 'invisible') {
            this.stage = prevStage = 'invisible';
            return;
          }

          if (stage === 'done') {
            this.timeout = setTimeout(
              action('hide progress bar once done', () => {
                this.stage = 'invisible';
              }),
              HIDE_TIMEOUT,
            );
          } else if (
            stage === 'loading' && (
              prevStage === 'done' ||
              prevStage === 'invisible'
            )
          ) {
            this.stage = 'start';
            this.timeout = setTimeout(
              action('restart progress bar', () => {
                this.stage = 'loading';
              }),
              RESTART_TIMEOUT,
            );
          }

          prevStage = stage;
        },
        {
          fireImmediately: true,
          name: 'hide progress bar once done',
        },
      ),
    ];
  }
  @action UNSAFE_componentWillReceiveProps(nextProps) {
    let stage = 'invisible';
    if (nextProps.done) stage = 'done';
    else if (nextProps.loading) stage = 'loading';
    this.stage = stage;
  }
  componentWillUnmount() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }

  render() {
    const {
      position, theme, withRadius,
    } = this.props;

    return (
      <div
        className={cn([
          `ProgressBar`,
          `ProgressBar--${position}`,
          `ProgressBar--${theme}`,
          withRadius && `ProgressBar--with-radius`,
          `ProgressBar--${this.stage}`,
        ])}
      />
    );
  }
}

export default ProgressBar;



// WEBPACK FOOTER //
// ./spa/Components/ProgressBar.jsx